import { ActionIcon, AppShell, Burger, Group, Text, Title, Tooltip } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconLogout } from "@tabler/icons-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Outlet, useNavigate } from "react-router-dom";
import { api } from "../api/client";
import { HistorySidebar } from "./HistorySidebar";

export function AppLayout() {
  const [opened, { toggle }] = useDisclosure(false);
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const logoutMutation = useMutation({
    mutationFn: () => api.logout(),
    onSettled: () => {
      // Чистим query-cache (особенно ['me']) и уходим на /login.
      queryClient.clear();
      navigate("/login", { replace: true });
    },
  });

  return (
    <AppShell
      header={{ height: 60 }}
      navbar={{
        width: 320,
        breakpoint: "sm",
        collapsed: { mobile: !opened },
      }}
      padding="md"
    >
      <AppShell.Header>
        <Group h="100%" px="md" justify="space-between">
          <Group gap="sm">
            <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
            <Title order={3}>🧩 MetaTRIZ</Title>
            <Text size="sm" c="dimmed" visibleFrom="sm">
              Multi-agent ТРИЗ-система
            </Text>
          </Group>
          <Tooltip label="Выйти">
            <ActionIcon
              variant="subtle"
              color="gray"
              onClick={() => logoutMutation.mutate()}
              loading={logoutMutation.isPending}
              aria-label="Выйти"
            >
              <IconLogout size={18} />
            </ActionIcon>
          </Tooltip>
        </Group>
      </AppShell.Header>

      <AppShell.Navbar p="md">
        <HistorySidebar />
      </AppShell.Navbar>

      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
}
